import './PdfModal.css';

import { Modal } from 'antd';
import { bool, func, string } from 'prop-types';
import React from 'react';

const PdfModal = React.memo(({ open, pdfModalClose, pdfModalTitle, pdfModalUrl }) => {
  if (!open) return null;

  return (
    <Modal
      className="partner-agreement-modal"
      title={pdfModalTitle}
      visible
      footer={null}
      mask={false}
      destroyOnClose
      onCancel={pdfModalClose}
    >
      <iframe src={pdfModalUrl} title={pdfModalTitle} />
    </Modal>
  );
});

PdfModal.propTypes = {
  pdfModalClose: func,
  pdfModalTitle: string,
  pdfModalUrl: string,
  open: bool.isRequired,
};

export default PdfModal;
